<template>
  <v-container fluid class="pa-4 pa-md-8">
    <!-- CARGA GLOBAL -->
    <v-overlay :value="cargar">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card class="mx-auto" max-width="1900">
      <!-- ENCABEZADO PRINCIPAL -->
      <v-card-title class="py-4 text-start">
        <v-icon large left>mdi-chart-pie</v-icon>
        <span class="text-h5 font-weight-bold">Dashboard Publicidad - Resumen Diario</span>
        <v-spacer></v-spacer>
        <v-chip large color="primary">
          {{ getReportTimeSlot }} resumen del {{ today }}
        </v-chip>
      </v-card-title>
      <v-row>
        <v-col md="7">
          <v-btn color="primary" dark @click="dialogFechaDescargaReporte = true" class="mb-4 mx-2">
            <!-- <v-btn color="primary" dark @click="dialogFechaDescargaReporte = true" class="mb-4 mx-2"> -->
            <v-icon left>mdi-download</v-icon>
            Descargar reporte de hoy
          </v-btn>
          <v-btn color="error" dark @click="modalConjuntos = true" class="mb-4 mx-2">
            <v-icon left>mdi-alert</v-icon>
            Conjuntos críticos
          </v-btn>
          <v-btn color="indigo darken-4" dark @click="dialogDiagnosticoIA = true" class="mb-4 mx-2">
            <v-icon left>mdi-brain</v-icon>
            Análisis Estratégico IA
          </v-btn>
          <v-btn color="teal darken-2" dark @click="dialogDiagnosticoLocal = true" class="mb-4 mx-2">
            <v-icon left>mdi-stethoscope</v-icon>
            Diagnóstico Operativo
          </v-btn>
        </v-col>
      </v-row>
      <!-- PESTAÑAS PRINCIPALES (Nivel superior para acceso rápido) -->
      <v-tabs v-model="mainTab" color="teal darken-3" grow show-arrows>
        <v-tab><v-icon left>mdi-home-analytics</v-icon> Resumen General</v-tab>
        <v-tab><v-icon left>mdi-city</v-icon> Ciudades & Sucursales</v-tab>
        <v-tab><v-icon left>mdi-facebook</v-icon> Plataformas</v-tab>
        <v-tab><v-icon left>mdi-crystal-ball</v-icon> Predicciones</v-tab>
        <v-tab><v-icon left>mdi-bullseye-arrow</v-icon> Clonación & Unicornios</v-tab>
        <v-tab><v-icon left>mdi-playlist-check</v-icon> Checklist Operativo ({{ totalPendientes }})</v-tab>
        <v-tab><v-icon left>mdi-table-large</v-icon> Detalle Anuncios</v-tab>
        <v-tab><v-icon left>mdi-account-tie</v-icon> Encargados</v-tab>
      </v-tabs>

      <v-tabs-items v-model="mainTab">
        <!-- ==================== TAB 1: RESUMEN GENERAL ==================== -->
        <v-tab-item>
          <v-card-text class="pa-6" v-if="getSuccess">
            <v-row>
              <!-- Resumen Operativo -->
              <v-col cols="12" md="4">
                <v-card elevation="12" class="rounded-xl">
                  <v-card-title class="orange darken-4 white--text">
                    <v-icon left dark>mdi-chart-donut</v-icon>
                    Resumen Operativo General
                  </v-card-title>
                  <v-card-text class="pt-5">
                    <div class="text-h6">Total anuncios activos: <strong>{{ getResumenOperativo.total_anuncios
                        }}</strong></div>
                    <div class="text-h6 mb-4">Riesgo dinero en juego:
                      <span class="red--text text--darken-3 font-weight-bold">${{ getResumenOperativo.riesgo_dinero |
                        decimales }}</span>
                    </div>
                    <v-divider class="mb-4"></v-divider>
                    <v-row dense>
                      <v-col cols="6" v-for="(valor, accion) in getResumenOperativo.acciones" :key="accion">
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-chip :color="getAccionColor(accion)" dark block v-on="on"
                              @click="abrirDetalleAccion(accion)">
                              {{ accion.replace('_', ' ') }}: {{ valor }}
                            </v-chip>

                          </template>
                          <span>
                            {{ getTooltipAccion(accion) }}
                          </span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text color="orange darken-4" @click="dialogResumenOperativo = true">
                      Ver explicación completa
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>

              <!-- Total Empresa -->
              <v-col cols="12" md="4">
                <v-card :color="getCardColor(getTotal)" dark elevation="12" class="rounded-xl">
                  <v-card-title class="text-h6">
                    <v-icon left>mdi-domain</v-icon>
                    {{ getTotal.nombre }}
                  </v-card-title>
                  <v-card-text>
                    <div class="text-h3 font-weight-black">{{ getTotal.cumplimiento }}</div>
                    <div class="text-subtitle-1">Presupuesto diario: ${{ getTotal.presupuesto_diario | decimales }}
                    </div>
                    <div class="text-subtitle-1">Gasto ayer: ${{ getTotal.gasto_ayer | decimales }}</div>
                    <div class="text-subtitle-1">CPA ayer: ${{ getTotal.cpa_ayer | decimales }}</div>
                    <div class="text-subtitle-1">Leads ayer: {{ getTotal.leads_ayer }}</div>
                    <v-chip class="mt-4" large :color="getChipPresupuestoColor(getTotal.estado)" dark>
                      {{ getTotal.estado }}
                    </v-chip>
                  </v-card-text>
                </v-card>
              </v-col>

              <!-- Top 5 Sobregasto Sucursales -->
              <v-col cols="12" md="4">
                <v-card elevation="12" class="rounded-xl">
                  <v-card-title class="red darken-4 white--text">
                    <v-icon left dark>mdi-alert-decagram</v-icon>
                    Top 5 Sucursales con Mayor Sobregasto
                  </v-card-title>
                  <v-card-text>
                    <v-simple-table dense>
                      <thead>
                        <tr>
                          <th>Sucursal</th>
                          <th class="text-right">Cumplimiento</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(s, i) in topSucursalesSobregasto" :key="i">
                          <td><strong>{{ s.nombre }}</strong></td>
                          <td class="text-right red--text font-weight-bold">{{ s.cumplimiento }}</td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 2: CIUDADES & SUCURSALES ==================== -->
        <v-tab-item>
          <v-card-text class="pa-6" v-if="getSuccess">
            <v-row>
              <v-col cols="12" md="4" v-for="(ciudad, i) in getCiudadesOrSucursales" :key="'city-main-' + i">
                <v-card :color="getCardColor(ciudad)" dark elevation="10" class="rounded-xl">
                  <v-card-title>
                    <v-icon left>{{ ciudad.nombre === 'ONLINE' ? 'mdi-cast-education' : 'mdi-city' }}</v-icon>
                    {{ ciudad.nombre }}
                  </v-card-title>
                  <v-card-text>
                    <div class="text-h4 font-weight-black">{{ ciudad.cumplimiento }}</div>
                    <div>Gasto ayer: ${{ ciudad.gasto_ayer | decimales }}</div>
                    <div>Leads ayer: {{ ciudad.leads_ayer }}</div>
                    <div>CPA 7d: ${{ ciudad.cpa_promedio_7d | decimales }}</div>
                    <v-chip class="mt-3" :color="getChipPresupuestoColor(ciudad.estado)" dark>
                      {{ ciudad.estado }}
                    </v-chip>
                  </v-card-text>
                  <v-card-actions>
                    <v-row align="center">
                      <v-col class="text-left">
                        <v-btn text dark @click="openDialogCiudad(ciudad)">Detalle</v-btn>
                      </v-col>
                      <v-col class="text-right" v-if="idSchool == 1">
                        <v-btn class="mt-3" color="white" outlined rounded @click="openDialogTopGastosCiudad(ciudad)">
                          Top Gastos
                          <v-icon right>mdi-progress-star</v-icon>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-8"></v-divider>

            <!-- Sucursales Críticas -->
            <div class="text-h6 mb-4">
              <v-icon left>mdi-store</v-icon>
              Estatus de las sucursales
            </div>
            <div class="d-flex justify-end align-end text-left">
              <v-radio-group v-model="filterSucursales" row>
                <v-radio label="SIN ANUNCIOS" value="SIN_INFO"></v-radio>
                <v-radio label="CRÍTICO" value="CRITICO"></v-radio>
                <v-radio label="ALERTA" value="ALERTA"></v-radio>
                <v-radio label="OPTIMO" value="OPTIMO"></v-radio>
              </v-radio-group>
            </div>
            <v-row v-if="sucursalesCriticas.length">
              <v-col cols="12" md="4" v-for="(suc, i) in sucursalesCriticas" :key="'crit-' + i">
                <v-card :color="getSucursalCardColor(suc.estatus_global)" dark elevation="10" class="rounded-xl">
                  <v-card-title>
                    <v-icon v-if="filterSucursales == 'OPTIMO'" left>mdi-checkbox-marked-circle-auto-outline</v-icon>
                    <v-icon v-else-if="filterSucursales == 'ALERTA'" left>mdi-alert-circle</v-icon>
                    <v-icon v-else-if="filterSucursales == 'SIN CAMPAÑAS'" left>mdi-circle-off-outline</v-icon>
                    <v-icon v-else left>mdi-alert</v-icon>
                    {{ suc.sucursal }}
                  </v-card-title>
                  <v-card-text>
                    <div><strong>Recomendación:</strong> {{ suc.recomendacion }}</div>
                    <v-row>
                      <v-col>
                        <span class="mt-2"><strong>Conversaciones totales:</strong> {{ suc.metricas.conversaciones_total
                          }}</span> <br>
                        <span class="mt-2"><strong>Gasto total:</strong> ${{ suc.metricas.gasto_total }}</span> <br>
                        <span class="mt-2"><strong>CPA 7d:</strong> ${{ suc.metricas.cpa_7d }}</span> <br>
                      </v-col>
                      <v-col class="text-right">
                        <v-chip class="mt-3" color="white">
                          <v-tooltip bottom v-for="(val, key) in suc.conteo_campanas" :key="key">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" :color="val ? 'green' : 'red'" small class="mr-1">
                                {{ val ? 'mdi-check-circle' : 'mdi-close-circle' }}
                              </v-icon>
                            </template>
                            <span>{{ key }}: {{ val ? 'Cubierto' :
                              'Falta - Recomendación: Activa campaña inmediatamente para mejorar leads.' }}</span>
                          </v-tooltip>
                        </v-chip>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-else>
              <v-col class="text-center">
                <strong>Sin resultados</strong>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 3: PLATAFORMAS ==================== -->
        <v-tab-item>
          <v-card-text class="pa-6" v-if="getSuccess">
            <v-card elevation="12" class="mb-6 rounded-xl">
              <v-card-title :class="'white--text ' + getGanadorGeneralColor">
                <v-icon left dark v-if="getReporteGeneral.ganador.includes('INSTAGRAM')">mdi-instagram</v-icon>
                <v-icon left dark v-else>mdi-facebook</v-icon>
                <strong>Plataforma ganadora global: </strong> {{ getReporteGeneral.ganador }}
              </v-card-title>
              <v-card-text>
                <v-row justify="center">
                  <v-col v-for="(producto, key) in getReportePorProducto" :key="key" cols="12" sm="6" md="4" lg="3">

                    <v-card class="mx-auto rounded-xl my-1" max-width="400">
                      <v-card-title :class="getGanadorProductoColor(producto.ganador) + ' py-4 white--text'">
                        {{ producto.producto }}
                      </v-card-title>
                      <v-divider></v-divider>
                      <v-card-text>
                        <strong>GANADOR:</strong> <v-chip small
                          :color="getGanadorProductoColor(producto.ganador) + ' white--text'" dark>
                          {{ producto.ganador }}
                        </v-chip> <br>
                        <div class="text-subtitle-1">CPA: ${{ producto[getTagGanador(producto.ganador)].cpa | decimales
                          }}</div>
                        <div class="text-subtitle-1">Gasto: ${{ producto[getTagGanador(producto.ganador)].gasto |
                          decimales }}</div>
                        <div class="text-subtitle-1">Leads: {{ producto[getTagGanador(producto.ganador)].leads }}</div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-row>
              <v-col cols="12" md="6">
                <v-card elevation="10" class="rounded-xl">
                  <v-card-title class="blue darken-3 white--text">
                    <v-icon left dark>mdi-facebook</v-icon>
                    Facebook - Rendimiento General
                  </v-card-title>
                  <v-card-text>
                    <div class="mt-2 font-weight-bold">
                      <div>Gasto total: ${{ getReporteGeneral.facebook.gasto | decimales }}</div>
                      <div>Leads: {{ getReporteGeneral.facebook.leads }}</div>
                      <div>CPA promedio: ${{ getReporteGeneral.facebook.cpa | decimales }}</div>
                    </div>
                    <br>
                    <v-tabs v-model="plataformasFacebookTab" color="teal darken-3" grow show-arrows>
                      <v-tab v-if="idSchool == 1"><v-icon left>mdi-city</v-icon> Por ciudad</v-tab>
                      <v-tab><v-icon left>mdi-office-building-marker-outline</v-icon> Por sucursal</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="plataformasFacebookTab">
                      <v-tab-item v-if="idSchool == 1">
                        <v-expansion-panels class="mt-0" flat>
                          <v-expansion-panel v-for="(ciudad, nombre) in getPorPlataformaPorCiudad.facebook"
                            :key="nombre">
                            <v-expansion-panel-header class=" text-left ml-0 pl-0">
                              {{ nombre }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="text-left">
                              <strong>Gasto:</strong> ${{ ciudad.gasto | decimales }} <br>
                              <strong>Leads:</strong> {{ ciudad.leads }} <br>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-tab-item>
                      <v-tab-item>
                        <v-expansion-panels class="mt-0" flat>
                          <v-expansion-panel v-for="(sucursal, nombre) in getPorPlataformaPorSucursal.facebook"
                            :key="nombre">
                            <v-expansion-panel-header class=" text-left ml-0 pl-0">
                              {{ nombre }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="text-left">
                              <strong>Gasto:</strong> ${{ sucursal.gasto | decimales }} <br>
                              <strong>Leads:</strong> {{ sucursal.leads }} <br>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card elevation="10" class="rounded-xl">
                  <v-card-title class="pink darken-3 white--text">
                    <v-icon left dark>mdi-instagram</v-icon>
                    Instagram - Rendimiento General
                  </v-card-title>
                  <v-card-text>
                    <div class="mt-2 font-weight-bold">
                      <div>Gasto total: ${{ getReporteGeneral.instagram.gasto | decimales }}</div>
                      <div>Leads: {{ getReporteGeneral.instagram.leads }}</div>
                      <div>CPA promedio: ${{ getReporteGeneral.instagram.cpa | decimales }}</div>
                    </div>
                    <br>
                    <v-tabs v-model="plataformasInstagramTab" color="teal darken-3" grow show-arrows>
                      <v-tab v-if="idSchool == 1"><v-icon left>mdi-city</v-icon> Por ciudad</v-tab>
                      <v-tab><v-icon left>mdi-office-building-marker-outline</v-icon> Por sucursal</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="plataformasInstagramTab">
                      <v-tab-item v-if="idSchool == 1">
                        <v-expansion-panels class="mt-0" flat>
                          <v-expansion-panel v-for="(ciudad, nombre) in getPorPlataformaPorCiudad.instagram"
                            :key="nombre">
                            <v-expansion-panel-header class=" text-left ml-0 pl-0">
                              {{ nombre }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="text-left">
                              <strong>Gasto:</strong> ${{ ciudad.gasto | decimales }} <br>
                              <strong>Leads:</strong> {{ ciudad.leads }} <br>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-tab-item>
                      <v-tab-item>
                        <v-expansion-panels class="mt-0" flat>
                          <v-expansion-panel v-for="(sucursal, nombre) in getPorPlataformaPorSucursal.instagram"
                            :key="nombre">
                            <v-expansion-panel-header class=" text-left ml-0 pl-0">
                              {{ nombre }}
                            </v-expansion-panel-header>
                            <v-expansion-panel-content class="text-left">
                              <strong>Gasto:</strong> ${{ sucursal.gasto | decimales }} <br>
                              <strong>Leads:</strong> {{ sucursal.leads }} <br>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 4: PREDICCIONES ==================== -->
        <v-tab-item>
          <v-card-text class="pa-6" v-if="getSuccess">
            <v-card elevation="12" class="mb-6 rounded-xl">
              <v-card-title class="green darken-3 white--text">
                <v-icon left dark>mdi-trending-up</v-icon>
                Panorama General de Hoy
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="4">
                    <div class="text-h4 font-weight-bold">{{ getPanoramaGeneral.ayer_real }}</div>
                    <div class="text-caption">Leads ayer (real)</div>
                  </v-col>
                  <v-col cols="4">
                    <div class="text-h4 font-weight-bold green--text">{{ getPanoramaGeneral.hoy_proyectado }}</div>
                    <div class="text-caption">Leads proyectados hoy</div>
                  </v-col>
                  <v-col cols="4">
                    <div class="text-h4 font-weight-bold green--text">{{ getPanoramaGeneral.diferencia }}</div>
                    <div class="text-caption">Diferencia proyectada</div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
            <v-tabs v-model="prediccionesTab" color="teal darken-3" grow show-arrows>
              <v-tab v-if="idSchool == 1"><v-icon left>mdi-city</v-icon> Por ciudad</v-tab>
              <v-tab><v-icon left>mdi-office-building-marker-outline</v-icon> Por sucursal</v-tab>
            </v-tabs>
            <v-tabs-items v-model="prediccionesTab">
              <v-tab-item v-if="idSchool == 1">
                <v-row class="ma-2">
                  <v-col cols="12" md="4" v-for="(pred, i) in getPrediccionesPorCiudad" :key="'pred-city-' + i">
                    <v-card elevation="8" class="rounded-xl">
                      <v-card-title class="teal darken-2 white--text">
                        {{ pred.ciudad }}
                      </v-card-title>
                      <v-card-text>
                        <strong>Ayer: {{ pred.ayer_real }} → Hoy: {{ pred.hoy_proyectado }}</strong>
                        <div class="mt-2 font-weight-bold" :class="pred.color === '🟢' ? 'green--text' : 'red--text'">
                          {{ pred.diferencia }} ({{ pred.tendencia }})
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item>
                <v-row class="ma-2">
                  <v-col cols="12" md="4" v-for="(pred, i) in getPrediccionesPorSucursal" :key="'pred-city-' + i">
                    <v-card elevation="8" class="rounded-xl">
                      <v-card-title class="teal darken-2 white--text">
                        {{ pred.sucursal }}
                      </v-card-title>
                      <v-card-text>
                        <strong>Ayer: {{ pred.ayer_real }} → Hoy: {{ pred.hoy_proyectado }}</strong>
                        <div class="mt-2 font-weight-bold" :class="pred.color === '🟢' ? 'green--text' : 'red--text'">
                          {{ pred.diferencia }} ({{ pred.tendencia }})
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 5: CLONACIÓN & UNICORNIOS ==================== -->
        <v-tab-item>
          <v-card-text class="pa-6" v-if="getSuccess && getInstruccionesClonacion.length">
            <v-alert prominent type="success" class="mb-6">
              <strong>Se detectaron {{ getInstruccionesClonacion.length }} anuncios UNICORNIO listos para
                clonar</strong>
            </v-alert>

            <v-row>
              <v-col cols="12" md="6" v-for="(inst, i) in getInstruccionesClonacion" :key="'clon-' + i">
                <v-card :color="inst.tipo === 'OPORTUNIDAD_POLINIZACION' ? 'purple darken-1' : 'orange darken-2'"
                  elevation="12" class="rounded-xl">
                  <v-card-title class="white--text">
                    <v-icon color="white" left>mdi-bullseye-arrow</v-icon>
                    Anuncio Unicornio Detectado
                  </v-card-title>
                  <v-card-text class="white">
                    <v-list>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Origen</v-list-item-title>
                          <v-list-item-subtitle>
                            <span><strong>ID Anuncio: </strong> {{ inst.origen.id_anuncio }}</span> <br>
                            <span><strong>Campaña: </strong> {{ inst.origen.campana }}</span> <br>
                            <span><strong>Conjunto: </strong> {{ inst.origen.conjunto }}</span> <br>
                            <span><strong>CPA Actual: </strong> {{ inst.origen.cpa_actual }}</span> <br>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Destino: {{ inst.destino.sucursal }}</v-list-item-title>
                          <v-list-item-subtitle>
                            <span><strong>Campaña: </strong> {{ inst.destino.campana }}</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <div class="mt-3"><strong>Instrucción técnica:</strong></div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div style="cursor:pointer;" v-on="on" @click="copyToClipboard(inst.instruccion_tecnica)">
                          {{ inst.mensaje_humano }}
                          <v-icon right>mdi-content-copy</v-icon>
                        </div>
                      </template>
                      Copiar al portapapeles
                    </v-tooltip>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-alert prominent type="info" class="my-6 mx-2" v-else>
            <strong>No se detectaron anuncios para clonar</strong>
          </v-alert>
        </v-tab-item>

        <!-- ==================== TAB 6: CHECKLIST OPERATIVO ==================== -->
        <v-tab-item>
          <v-container fluid class="pa-6">

            <!-- 1. UNICORNIOS → Verde y grande -->
            <v-card class="mb-8 rounded-xl" v-if="getUnicornios.length">
              <v-card-title class="text-h5 green darken-3 mb-2 white--text">
                <v-icon large left color="white">mdi-trophy</v-icon>
                CLONAR YA - {{ getUnicornios.length }} anuncios ESTELARES detectados
              </v-card-title>
              <v-card-text>
                <v-tabs v-model="unicorniosTab" color="teal darken-3" grow show-arrows>
                  <v-tab><v-icon left>mdi-exclamation-thick</v-icon> No ejecutadas</v-tab>
                  <v-tab><v-icon left>mdi-check-bold</v-icon>Ejecutadas</v-tab>
                </v-tabs>
                <v-tabs-items v-model="unicorniosTab">
                  <v-tab-item>
                    <v-row>
                      <v-col v-for="(u, index) in getUnicornios" :key="index" cols="12" md="6">
                        <v-alert prominent text color="success" border="left" class="mb-3">
                          <span class="font-weight-bold">Prioridad: </span>{{ u.prioridad }}
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Origen</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span><strong>ID Anuncio: </strong> {{ u.origen.id_anuncio }}</span> <br>
                                  <span><strong>Campaña: </strong> {{ u.origen.campana }}</span> <br>
                                  <span><strong>Conjunto: </strong> {{ u.origen.conjunto }}</span> <br>
                                  <span><strong>CPA Actual: </strong> {{ u.origen.cpa_actual }}</span> <br>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Destino: {{ u.destino.sucursal }}</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span><strong>Campaña: </strong> {{ u.destino.campana }}</span>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <span class="font-weight-bold">{{ u.mensaje_humano ||
                            'Clonar a todas las sucursales rentables' }}</span>
                          <v-checkbox v-model="checklistClon" @change="crearOActualizarPolinizacion(u)" :value="index"
                            label="Hecho" class="mt-2"></v-checkbox>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <!-- Ejecutadas -->
                  <v-tab-item>
                    <v-row>
                      <v-col v-for="(u, index) in getUnicorniosEjecutados" :key="index" cols="12" md="6">
                        <v-alert prominent text color="success" border="left" class="mb-3">
                          <span class="font-weight-bold">Prioridad: </span>{{ u.prioridad }} <br>
                          <span class="font-weight-bold">Fecha de creación: </span>{{ u.creado_el }} <br>
                          <span class="font-weight-bold">Fecha de ejecución: </span>{{ u.aplicado_el }} <br>
                          <span class="font-weight-bold">Ejecutado por: </span>{{ u.ejecutado_por }} <br>
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Origen</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span><strong>ID Anuncio: </strong> {{ u.origen.id_anuncio }}</span> <br>
                                  <span><strong>Campaña: </strong> {{ u.origen.campana }}</span> <br>
                                  <span><strong>Conjunto: </strong> {{ u.origen.conjunto }}</span> <br>
                                  <span><strong>CPA Actual: </strong> {{ u.origen.cpa_actual }}</span> <br>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Destino: {{ u.destino.sucursal }}</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span><strong>Campaña: </strong> {{ u.destino.campana }}</span>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <!-- <v-checkbox v-model="checklistClon" @change="crearOActualizarPolinizacion(u)" :value="index"
                            label="Hecho" class="mt-2"></v-checkbox> -->
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <v-alert prominent type="info" class="mb-6" v-else>
              <strong>No se detectaron anuncios para clonar</strong>
            </v-alert>

            <!-- 2. APAGAR YA → Rojo fuerte -->
            <v-card class="mb-8 rounded-xl">
              <v-card-title class="text-h5 red darken-4 white--text">
                <v-icon large left color="white">mdi-fire</v-icon>
                APAGAR INMEDIATAMENTE - {{ getApagarYa.length }} anuncios tóxicos
              </v-card-title>
              <v-card-text class="white--text">
                <v-tabs v-model="apagarTab" color="teal darken-3" grow show-arrows>
                  <v-tab><v-icon left>mdi-exclamation-thick</v-icon> No ejecutadas</v-tab>
                  <v-tab><v-icon left>mdi-check-bold</v-icon>Ejecutadas</v-tab>
                </v-tabs>
                <v-tabs-items v-model="apagarTab">
                  <v-tab-item>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>ID Anuncio</th>
                          <th>Anuncio</th>
                          <th>Sucursal</th>
                          <th>Gasto 7d</th>
                          <th>Leads</th>
                          <th>CPA</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(a, index) in getApagarYa" :key="index">
                          <td>{{ a.ad_id }}</td>
                          <td>{{ a.ad_name }}</td>
                          <td>{{ a.branch }}</td>
                          <td v-if="a.spend_7d">${{ a.spend_7d | decimales }}</td>
                          <td v-else>${{ a.spend | decimales }}</td>
                          <td>{{ a.whatsapp_conversations || 0 }}</td>
                          <td class="red--text">${{ a.cost_per_whatsapp | decimales }}</td>
                          <td><v-checkbox v-model="checklistOff" @change="apagarAnuncio(a)" :value="index"
                              label="Apagado"></v-checkbox></td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>

                  <v-tab-item>
                    <v-simple-table>
                      <thead>
                        <tr>
                          <th>ID Anuncio</th>
                          <th>Anuncio</th>
                          <th>Sucursal</th>
                          <th>Gasto 7d</th>
                          <th>Leads</th>
                          <th>CPA</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(a, index) in getApagados" :key="index">
                          <td>{{ a.ad_id }}</td>
                          <td>{{ a.ad_name }}</td>
                          <td>{{ a.branch }}</td>
                          <td v-if="a.spend_7d">${{ a.spend_7d | decimales }}</td>
                          <td v-else>${{ a.spend | decimales }}</td>
                          <td>{{ a.whatsapp_conversations || 0 }}</td>
                          <td class="red--text">${{ a.cost_per_whatsapp | decimales }}</td>
                          <!-- <td><v-checkbox v-model="checklistOff" @change="apagarAnuncio(a)" :value="index" label="Apagado"></v-checkbox></td> -->
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <!-- 3. ESCALAR -->
            <v-card class="mb-8 rounded-xl">
              <v-card-title class="text-h5 blue darken-1 mb-2 white--text">
                <v-icon large left color="white">mdi-trending-up</v-icon>
                ESCALAR HOY - {{ getEscalar.length }} anuncios rentables
              </v-card-title>
              <v-card-text>
                <v-tabs v-model="escalarTab" color="teal darken-3" grow show-arrows>
                  <v-tab><v-icon left>mdi-exclamation-thick</v-icon> No ejecutadas</v-tab>
                  <v-tab><v-icon left>mdi-check-bold</v-icon>Ejecutadas</v-tab>
                </v-tabs>
                <v-tabs-items v-model="escalarTab">
                  <v-tab-item>
                    <v-row>
                      <v-col v-for="(esca, index) in getEscalar" :key="index" cols="12" md="6">
                        <v-alert prominent text color="info" border="left" class="mb-3">
                          <span class="font-weight-bold">Recomendación: </span>{{ esca.action }}
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Detalle</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span><strong>ID Anuncio: </strong> {{ esca.ad_id }}</span> <br>
                                  <span><strong>Anuncio: </strong> {{ esca.ad_name }}</span> <br>
                                  <span><strong>Campaña: </strong> {{ esca.campaign_name }}</span> <br>
                                  <span><strong>Ciudad: </strong> {{ esca.city }}</span> <br>
                                  <span><strong>Producto: </strong> {{ esca.product }}</span> <br>
                                  <span><strong>Razón: </strong> {{ esca.reason }}</span> <br>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <v-checkbox v-model="checklistEscalar" @change="escalarAnuncio(esca)" :value="index"
                            label="Hecho" class="mt-2"></v-checkbox>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-tab-item>

                  <v-tab-item>
                    <v-row>
                      <v-col v-for="(esca, index) in getEscalados" :key="index" cols="12" md="6">
                        <v-alert prominent text color="info" border="left" class="mb-3">
                          <span class="font-weight-bold">Recomendación: </span>{{ esca.action }}
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Detalle</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span><strong>ID Anuncio: </strong> {{ esca.ad_id }}</span> <br>
                                  <span><strong>Anuncio: </strong> {{ esca.ad_name }}</span> <br>
                                  <span><strong>Campaña: </strong> {{ esca.campaign_name }}</span> <br>
                                  <span><strong>Ciudad: </strong> {{ esca.city }}</span> <br>
                                  <span><strong>Producto: </strong> {{ esca.product }}</span> <br>
                                  <span><strong>Razón: </strong> {{ esca.reason }}</span> <br>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <!-- <v-checkbox v-model="checklistEscalar" @change="escalarAnuncio(esca)" :value="index" label="Hecho" class="mt-2"></v-checkbox> -->
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <!-- 4. Sucursales CRÍTICAS -->
            <v-card class="mb-8 rounded-xl">
              <v-card-title class="text-h5 orange darken-3 mb-2 white--text">
                <v-icon large left color="white">mdi-store-alert</v-icon>
                SUCURSALES CRÍTICAS - {{ sucursalesCriticas.length }}
              </v-card-title>
              <v-card-text>
                <v-tabs v-model="sucCriticasTab" color="teal darken-3" grow show-arrows>
                  <v-tab><v-icon left>mdi-exclamation-thick</v-icon> No ejecutadas</v-tab>
                  <v-tab><v-icon left>mdi-check-bold</v-icon>Ejecutadas</v-tab>
                </v-tabs>
                <v-tabs-items v-model="sucCriticasTab">
                  <v-tab-item>
                    <v-row>
                      <v-col v-for="(sucursal, index) in sucursalesCriticas" :key="index" cols="12" md="6">
                        <v-alert prominent text color="warning" border="left" class="mb-3">
                          <span class="font-weight-bold">Sucursal: </span>{{ sucursal.sucursal }}
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Métricas</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span class="mt-2"><strong>Conversaciones totales:</strong> {{
                                    sucursal.metricas.conversaciones_total }}</span> <br>
                                  <span class="mt-2"><strong>Gasto total:</strong> ${{ sucursal.metricas.gasto_total
                                    }}</span> <br>
                                  <span class="mt-2"><strong>CPA 7d:</strong> ${{ sucursal.metricas.cpa_7d }}</span>
                                  <br>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Conteo de campañas</v-list-item-title>
                                <v-list-item-subtitle>
                                  <div v-for="(conteo, index) of sucursal.conteo_campanas" :key="index">
                                    <span><strong>{{ index }}: </strong> {{ conteo }}</span> <br>
                                  </div>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <span class="font-weight-bold">{{ sucursal.recomendacion }}</span>
                          <v-checkbox v-model="checklistSucursalesCrit" @change="atenderSucursal(sucursal)"
                            :value="index" label="Hecho" class="mt-2"></v-checkbox>
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row>
                      <v-col v-for="(sucursal, index) in sucursalesCriticasAtendidas" :key="index" cols="12" md="6">
                        <v-alert prominent text color="warning" border="left" class="mb-3">
                          <span class="font-weight-bold">Sucursal: </span>{{ sucursal.sucursal }}
                          <v-list>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Métricas</v-list-item-title>
                                <v-list-item-subtitle>
                                  <span class="mt-2"><strong>Conversaciones totales:</strong> {{
                                    sucursal.metricas.conversaciones_total }}</span> <br>
                                  <span class="mt-2"><strong>Gasto total:</strong> ${{ sucursal.metricas.gasto_total
                                    }}</span> <br>
                                  <span class="mt-2"><strong>CPA 7d:</strong> ${{ sucursal.metricas.cpa_7d }}</span>
                                  <br>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content>
                                <v-list-item-title>Conteo de campañas</v-list-item-title>
                                <v-list-item-subtitle>
                                  <div v-for="(conteo, index) of sucursal.conteo_campanas" :key="index">
                                    <span><strong>{{ index }}: </strong> {{ conteo }}</span> <br>
                                  </div>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                          <span class="font-weight-bold">{{ sucursal.recomendacion }}</span>
                          <!-- <v-checkbox v-model="checklistSucursalesCrit" @change="atenderSucursal(sucursal)" :value="index" label="Hecho"
                            class="mt-2"></v-checkbox> -->
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                </v-tabs-items>
              </v-card-text>
            </v-card>

            <!-- Botón final de "Todo listo" -->
            <v-alert border="bottom" color="pink darken-1" class="mt-8 text-center font-weight-bold" dark
              v-if="totalPendientes - getChecklistTotal > 0">
              {{ getChecklistTotal + ' atendidos de ' + totalPendientes + ' Pendientes' }}
            </v-alert>
            <v-alert border="bottom" color="green darken-2" class="mt-8 text-center font-weight-bold" dark v-else>
              ¡Checklist completado hoy!
            </v-alert>
          </v-container>
        </v-tab-item>

        <!-- ==================== TAB 7: DETALLE ANUNCIOS ==================== -->
        <v-tab-item>
          <v-card-text class="pa-6" v-if="getSuccess">
            <v-card elevation="12" class="rounded-xl">
              <v-card-title>
                <v-spacer></v-spacer>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar anuncio..." single-line
                  clearable></v-text-field>
              </v-card-title>

              <v-data-table :headers="headers" :items="getDetallesOperativos" :search="search" :items-per-page="15"
                dense show-expand single-expand item-key="idRow" :expanded.sync="expandedOerativos" class="elevation-1">
                <!-- Slots de expansión y formato -->
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" class="pa-6 grey lighten-4">
                    <v-row>
                      <v-col cols="12" md="6">
                        <strong>ID Anuncio:</strong> {{ item.ad_id }}<br>
                        <strong>Campaña:</strong> {{ item.campaign_name }}<br>
                        <strong>Formato:</strong> {{ item.format }}<br>
                        <strong>Acción recomendada:</strong>
                        <v-chip small :color="getAccionOrdenColor(item.action)" dark class="ml-2">
                          {{ item.action }}
                        </v-chip><br>
                        <strong>Motivo:</strong> {{ item.reason }}<br>
                        <strong>Gasto sugerido mañana:</strong> ${{ item.gasto_sugerido_manana | decimales }}
                      </v-col>
                      <v-col cols="12" md="6">
                        <strong>Desglose por plataforma:</strong><br>
                        <div v-for="(plat, key) in item.desglose_plataforma" :key="key">
                          <strong>{{ key.toUpperCase() }}:</strong> Gasto ${{ plat.gasto | decimales }} | Leads {{
                          plat.leads }}
                        </div>
                      </v-col>
                    </v-row>
                  </td>
                </template>

                <template v-slot:item.spend="{ item }">
                  ${{ item.spend | decimales }}
                </template>
                <template v-slot:item.cpm="{ item }">
                  ${{ item.cpm | decimales }}
                </template>
                <template v-slot:item.ctr="{ item }">
                  {{ item.ctr | decimales }}%
                </template>
                <template v-slot:item.cost_per_whatsapp="{ item }">
                  <span :class="item.cost_per_whatsapp > 40 ? 'red--text' : 'green--text'">
                    ${{ item.cost_per_whatsapp | decimales }}
                  </span>
                </template>
                <template v-slot:item.status="{ item }">
                  <v-chip small :color="getStatusColor(item.status)" dark>
                    {{ item.status }}
                  </v-chip>
                </template>
              </v-data-table>
            </v-card>
          </v-card-text>
        </v-tab-item>

        <!-- ==================== TAB 8: ENCARGADOS POR SUCURSAL ==================== -->
        <v-tab-item>
          <v-card-text class="pa-6">
            <div class="d-flex flex-wrap align-center mb-4">
              <div>
                <div class="text-h6">
                  <v-icon left>mdi-store-marker</v-icon>
                  Encargado por sucursal
                </div>
                <div class="text-body-2 grey--text text--darken-1">
                  Elige a una persona de marketing como responsable de cada sucursal y guarda la asignación.
                </div>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                color="teal darken-2"
                dark
                class="mt-2"
                :disabled="!encargadosPendientes.length"
                :loading="guardandoEncargados"
                @click="guardarTodosEncargados"
              >
                <v-icon left>mdi-content-save</v-icon>
                Guardar cambios ({{ encargadosPendientes.length }})
              </v-btn>
            </div>

            <v-text-field
              v-model="buscarEncargado"
              append-icon="mdi-magnify"
              label="Buscar sucursal"
              filled
              dense
              hide-details
              clearable
              class="mb-4"
              style="max-width: 360px"
            ></v-text-field>

            <v-data-table
              :headers="headersEncargados"
              :items="sucursalesEncargado"
              :search="buscarEncargado"
              :loading="cargandoEncargados"
              dense
              item-key="id_plantel"
              :items-per-page="25"
              class="elevation-1"
              no-data-text="No hay sucursales para esta escuela"
            >
              <template v-slot:item.id_usuario="{ item }">
                <v-autocomplete
                  v-model="item.id_usuario"
                  :items="personasEncargadoDe(item)"
                  item-text="nombre_completo"
                  item-value="id_usuario"
                  label="Persona encargada"
                  filled
                  dense
                  hide-details
                  clearable
                  :disabled="item.guardando"
                ></v-autocomplete>
              </template>
              <template v-slot:item.acciones="{ item }">
                <v-btn
                  small
                  color="primary"
                  :disabled="!encargadoSucursalCambio(item)"
                  :loading="item.guardando"
                  @click="guardarEncargadoSucursal(item)"
                >
                  Guardar
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-tab-item>
      </v-tabs-items>

      <v-divider></v-divider>

      <v-card-text class="text-right">
        <span>From doc: {{ getReportName }}</span>
      </v-card-text>
    </v-card>

    <!-- ====================== DIALOGS INFORMATIVOS ====================== -->

    <!-- Detalle por Acción Recomendada -->
    <v-dialog v-model="dialogDetalleAccion" max-width="1200" scrollable>
      <v-card v-if="accionSeleccionada">
        <v-card-title class="headline white--text" :class="getAccionColorClase(accionSeleccionada)">
          <v-icon left dark>{{ getIconoAccion(accionSeleccionada) }}</v-icon>
          Anuncios con acción: <strong>{{ accionSeleccionada.replace('_', ' ') || '' }}</strong>
          <v-spacer></v-spacer>
          <v-chip dark large>
            Total: {{ anunciosPorAccion.length }} anuncios
          </v-chip>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-data-table :headers="headersDetalleAccion" :items="anunciosPorAccion" :items-per-page="10" dense
            class="elevation-2">
            <template v-slot:item.spend="{ item }">
              ${{ item.spend | decimales }}
            </template>
            <template v-slot:item.cost_per_whatsapp="{ item }">
              <span :class="item.cost_per_whatsapp > 40 ? 'red--text' : 'green--text'">
                ${{ item.cost_per_whatsapp | decimales }}
              </span>
            </template>
            <template v-slot:item.action="{ item }">
              <v-chip small :color="getAccionOrdenColor(item.action)" dark>
                {{ item.action }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-3" dark @click="dialogDetalleAccion = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Resumen Operativo -->
    <v-dialog v-model="dialogResumenOperativo" max-width="800">
      <v-card class="rounded-xl">
        <v-card-title class="headline orange darken-3 white--text">
          <v-icon left dark>mdi-information</v-icon>
          ¿Qué significa cada acción recomendada?
        </v-card-title>
        <v-card-text class="pt-6">
          <v-list>
            <v-list-item v-for="(desc, accion) in accionesExplicadas" :key="accion">
              <v-row>
                <v-col cols="6" md="2">
                  <v-list-item-icon>
                    <v-chip :color="getAccionColor(accion)" dark small v-if="accion == 'APAGAR_YA'"> APAGAR YA</v-chip>
                    <v-chip :color="getAccionColor(accion)" dark small v-else>{{ accion }}</v-chip>
                  </v-list-item-icon>
                </v-col>
                <v-col cols="6" md="10">
                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold" v-if="accion == 'APAGAR_YA'">APAGAR
                      YA</v-list-item-title>
                    <v-list-item-title class="font-weight-bold" v-else>{{ accion }}</v-list-item-title>
                    <v-list-item-subtitle>{{ desc }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-col>
              </v-row>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange darken-3" dark @click="dialogResumenOperativo = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Diálogo Detalle Ciudad -->
    <v-dialog v-model="dialogCiudad" max-width="1000" scrollable>
      <v-card v-if="ciudadSeleccionada" class="rounded-xl">
        <v-card-title class="headline teal darken-3 white--text">
          Detalle Completo - {{ ciudadSeleccionada.nombre }}
        </v-card-title>
        <v-card-text class="pt-6">
          <v-simple-table>
            <tbody>
              <tr>
                <td><strong>Cumplimiento</strong></td>
                <td class="font-weight-bold text-h5">{{ ciudadSeleccionada.cumplimiento }}</td>
              </tr>
              <tr>
                <td>Presupuesto diario</td>
                <td>${{ ciudadSeleccionada.presupuesto_diario }}</td>
              </tr>
              <tr>
                <td>Gasto ayer</td>
                <td>${{ ciudadSeleccionada.gasto_ayer | decimales }}</td>
              </tr>
              <tr>
                <td>CPA ayer</td>
                <td>${{ ciudadSeleccionada.cpa_ayer | decimales }}</td>
              </tr>
              <tr>
                <td>Leads ayer</td>
                <td>{{ ciudadSeleccionada.leads_ayer }}</td>
              </tr>
              <tr>
                <td>CPA promedio 7d</td>
                <td>${{ ciudadSeleccionada.cpa_promedio_7d | decimales }}</td>
              </tr>
              <tr>
                <td>Leads promedio diario</td>
                <td>{{ ciudadSeleccionada.leads_promedio_diario }}</td>
              </tr>
              <tr>
                <td>Estado</td>
                <td><v-chip :color="getChipPresupuestoColor(ciudadSeleccionada.estado)" dark>{{
                    ciudadSeleccionada.estado
                    }}</v-chip></td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="teal darken-3" dark @click="dialogCiudad = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIÁLOGO: TOP GASTOS POR CIUDAD -->
    <v-dialog v-model="dialogTopGastosCiudad" max-width="1100" scrollable>
      <v-card class="rounded-xl" elevation="24" v-if="topInfo">
        <v-card-title class="headline white--text py-5 red darken-2">
          <v-icon large left dark>mdi-currency-usd-off</v-icon>
          Top 5 Anuncios con Mayor Gasto - {{ topInfo.ciudad }}
          <v-spacer></v-spacer>
          <v-chip dark large outlined>
            <v-icon left small>mdi-cash</v-icon>
            Total: ${{ getTotalGastado(topInfo.top5) | decimales }}
          </v-chip>
        </v-card-title>

        <v-card-text class="pt-8 pb-4">
          <div class="text-center mb-6 grey--text text--darken-1">
            <strong>{{ topInfo.cantidadAnuncios }}</strong> anuncios activos •
            Mostrando los 5 que más gastaron ayer
          </div>

          <v-data-table :headers="headers" :items="topInfo.top5" :search="search" show-expand single-expand
            item-key="idRow" :expanded.sync="expanded" hide-default-footer>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" class="pa-4 grey lighten-4 text-start">
                <v-row>
                  <v-col cols="12" md="6">
                    <strong>Campaña:</strong> {{ item.campaign_name }}<br>
                    <strong>Hook Rate:</strong> {{ item.hook_rate }}<br>
                    <strong>Hold Rate:</strong> {{ item.hold_rate }}<br>
                    <strong>Plataformas:</strong> <br>
                    <v-expansion-panels class="mt-0 grey lighten-4" flat>
                      <v-expansion-panel v-for="(plataforma, key) in item.desglose_plataforma" :key="key">
                        <v-expansion-panel-header class="grey lighten-4 text-left ml-0 pl-0">
                          <strong>{{ key }}</strong>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="text-left grey lighten-4">
                          <strong>Gasto:</strong> ${{ plataforma.gasto | decimales }} <br>
                          <strong>Leads:</strong> {{ plataforma.leads }} <br>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-col>
                  <v-col cols="12" md="6">
                    <strong>Tendencia:</strong> {{ item.trend_issue }}<br>
                    <strong>Acción:</strong> {{ item.action }}<br>
                    <strong>Razón:</strong> {{ item.reason }}<br>
                    <strong>Gasto sugerido mañana:</strong> ${{ item.gasto_sugerido_manana | decimales }}<br>
                  </v-col>
                </v-row>
              </td>
            </template>

            <template v-slot:item.spend="{ item }">
              ${{ item.spend | decimales }}
            </template>
            <template v-slot:item.cpm="{ item }">
              ${{ item.cpm | decimales }}
            </template>
            <template v-slot:item.ctr="{ item }">
              {{ item.ctr | decimales }}%
            </template>
            <template v-slot:item.cost_per_whatsapp="{ item }">
              ${{ item.cost_per_whatsapp | decimales }}
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip small :color="getAccionColorClase(item.status)" dark>
                {{ item.status }}
              </v-chip>
            </template>
          </v-data-table>
        </v-card-text>

        <v-card-actions class="grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="red darken-4" dark large @click="dialogTopGastosCiudad = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="modalConjuntos" max-width="900" persistent>
      <v-card>
        <!-- Título con alerta roja -->
        <v-card-title class="red darken-4 white--text headline">
          <v-icon large color="white" left>mdi-alert-octagon</v-icon>
          Conjuntos de Anuncios Críticos
          <v-spacer />
          <v-btn icon dark @click="modalConjuntos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pt-6">
          <v-alert border="left" colored-border type="warning" elevation="2" class="mb-6">
            Se encontraron <strong>{{ getConjuntosCriticos ? getConjuntosCriticos.length : 0 }} conjunto(s)</strong> con
            <strong>0 o 1 anuncio activo</strong>. Esto representa un riesgo alto de fatiga de creativo.
          </v-alert>

          <!-- Tabla clara y responsive -->
          <v-data-table :headers="headersConjuntos" :items="getConjuntosCriticos" :items-per-page="10"
            class="elevation-3" hide-default-footer no-data-text="¡Excelente! No hay conjuntos críticos">
            <!-- Sucursal con chip -->
            <template v-slot:item.sucursal="{ item }">
              <v-chip small color="primary" dark>
                {{ item.sucursal }}
              </v-chip>
            </template>

            <!-- Campaña -->
            <template v-slot:item.campaña="{ item }">
              <span class="font-weight-medium text-caption">{{ item.campaña }}</span>
            </template>

            <!-- Conjunto de anuncios -->
            <template v-slot:item.conjunto_de_anuncios="{ item }">
              <strong class="primary--text">{{ item.conjunto_de_anuncios }}</strong>
            </template>

            <!-- Cantidad de anuncios activos -->
            <template v-slot:item.anuncios_activos="{ item }">
              <v-chip :color="item.anuncios_activos === 0 ? 'red' : 'orange darken-2'" dark small
                class="font-weight-bold">
                {{ item.anuncios_activos }} activo{{ item.anuncios_activos === 1 ? '' : 's' }}
              </v-chip>
            </template>

            <!-- IDs de anuncios -->
            <template v-slot:item.ids_anuncios="{ item }">
              <div class="text-caption grey--text font-weight-medium">
                {{ item.ids_anuncios.join(', ') || '—' }}
              </div>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-3" text @click="modalConjuntos = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDiagnosticoIA" max-width="1200" scrollable transition="dialog-bottom-transition">
      <v-card class="rounded-xl overflow-hidden" elevation="24">
        <v-card-title class="headline indigo darken-4 white--text py-4 px-6">
          <v-icon large left color="white">mdi-brain</v-icon>
          Análisis Estratégico de Marketing (IA) — {{ today }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogDiagnosticoIA = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pa-0 grey lighten-5" v-if="getDiagnosticoIA">
          <v-container fluid class="pa-6">
            <!-- NIVEL 1: ESCUELA -->
            <v-row v-if="getDiagnosticoIA.escuela">
              <v-col cols="12">
                <v-card class="mb-6 elevation-4 rounded-lg overflow-hidden border-teal">
                  <v-card-title class="teal darken-3 white--text py-2 px-4 subtitle-1">
                    <v-icon small left color="white">mdi-office-building</v-icon>
                    Visión Global (Nivel Escuela)
                  </v-card-title>
                  <v-card-text class="pa-4 bg-white">
                    <div class="text-h6 mb-2 indigo--text text--darken-3 font-weight-bold">Resumen General</div>
                    <p class="text-body-1 line-height-relaxed">{{ getDiagnosticoIA.escuela.analisis }}</p>
                    <div class="mt-4 pa-3 rounded-lg amber lighten-4 grey--text text--darken-4 border-amber">
                      <strong>Recomendación Estratégica:</strong> {{ getDiagnosticoIA.escuela.recomendacion }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- NIVEL 2: CIUDADES -->
            <div class="text-h6 mb-3 px-2 font-weight-bold grey--text text--darken-3" v-if="getDiagnosticoIA.ciudades && getDiagnosticoIA.ciudades.length">
              Análisis por Ciudad
            </div>
            <v-row v-if="getDiagnosticoIA.ciudades">
              <v-col v-for="ciudad in getDiagnosticoIA.ciudades" :key="ciudad.nombre" cols="12" md="6"  v-if="ciudad.nombre != 'OTRO'">
                <v-card outlined class="mb-4 elevation-2 rounded-lg border-blue">
                  <v-card-title class="blue darken-3 white--text py-1 px-3 subtitle-2">
                    <v-icon x-small left color="white">mdi-city</v-icon>
                    {{ ciudad.nombre }}
                  </v-card-title>
                  <v-card-text class="pa-3">
                    <div class="mb-1"><strong>Análisis:</strong> {{ ciudad.analisis }}</div>
                    <div class="green--text text--darken-3"><strong>Ajuste:</strong> {{ ciudad.recomendacion }}</div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-divider class="my-6"></v-divider>

            <!-- NIVEL 3: SUCURSALES -->
            <div class="text-h6 mb-4 px-2 font-weight-bold grey--text text--darken-3">
              Estatus por Sucursal
            </div>
            <v-row v-if="getDiagnosticoIA.sucursales">
              <v-col v-for="suc in getDiagnosticoIA.sucursales" :key="suc.nombre" cols="12">
                <v-card outlined class="elevation-4 rounded-xl mb-6 overflow-hidden" :color="suc.estado === 'CRITICO'
                  ? 'red lighten-5'
                  : suc.estado === 'ALERTA'
                    ? 'orange lighten-5'
                    : 'green lighten-5'
                  " style="border-width: 2px !important;" :style="{ borderColor: getStatusBorderColor(suc.estado) }">
                  <v-card-title class="font-weight-black text-h5 py-4 px-6 d-flex align-center">
                    {{ suc.nombre }}
                    <v-spacer></v-spacer>
                    <v-chip :color="suc.estado === 'CRITICO' ? 'red darken-2' : suc.estado === 'ALERTA' ? 'orange darken-2' : 'green darken-2'" dark class="font-weight-bold px-6">
                      {{ suc.estado }}
                    </v-chip>
                  </v-card-title>
                  <v-divider :color="getStatusBorderColor(suc.estado)"></v-divider>
                  <v-card-text class="pa-6">
                    <v-row>
                      <v-col cols="12" md="7">
                        <div class="mb-4">
                          <div class="text-overline grey--text text--darken-1 mb-1">Análisis Detallado</div>
                          <div class="text-body-1 line-height-relaxed grey--text text--darken-4" style="font-size: 1.05rem !important;">
                            {{ suc.analisis }}
                          </div>
                        </div>
                        <div class="pa-4 rounded-lg white elevation-1 border-left-thick" :style="{ borderLeftColor: getStatusBorderColor(suc.estado) }">
                          <div class="text-subtitle-2 font-weight-bold mb-1" :style="{ color: getStatusBorderColor(suc.estado) }">Instrucción Operativa</div>
                          <div class="text-body-1 grey--text text--darken-3">{{ suc.recomendacion }}</div>
                        </div>
                      </v-col>
                      <v-col cols="12" md="5">
                        <div v-if="suc.anuncios_especificos && suc.anuncios_especificos.length">
                          <div class="text-overline red--text text--darken-2 mb-2">Auditoría de Anuncios Críticos</div>
                          <v-list dense bg-color="transparent" class="pa-0">
                            <v-list-item v-for="(anuncio, i) in suc.anuncios_especificos" :key="i" class="px-0 mb-2">
                              <v-list-item-icon class="mr-2 mt-1">
                                <v-icon color="red darken-2" small>mdi-close-octagon</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title class="text-body-2 line-height-base grey--text text--darken-4 text-wrap">
                                  {{ anuncio }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text class="pa-12 text-center" v-else>
          <v-icon size="64" color="grey lighten-1">mdi-brain</v-icon>
          <div class="text-h6 grey--text mt-4">No hay diagnóstico de IA disponible para este reporte.</div>
        </v-card-text>

        <v-card-actions class="pa-4 bg-white border-top">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-3" text @click="dialogDiagnosticoIA = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- MODAL 2: DIAGNÓSTICO OPERATIVO (LOCAL) -->
    <v-dialog v-model="dialogDiagnosticoLocal" max-width="1200" scrollable transition="dialog-bottom-transition">
      <v-card class="rounded-xl overflow-hidden" elevation="24">
        <v-card-title class="headline primary darken-2 white--text py-4 px-6">
          <v-icon large left color="white">mdi-stethoscope</v-icon>
          Diagnóstico Operativo Automático — {{ today }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogDiagnosticoLocal = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="pa-0 grey lighten-5">
          <v-container fluid class="pa-6">
            <div class="text-h6 mb-4 px-2 font-weight-bold grey--text text--darken-3">
              Estatus de Rendimiento por Sucursal (Reglas Manuales)
            </div>
            <v-row>
              <v-col v-for="(diag, suc) in localLevelDiagnoses" :key="suc" cols="12" md="6" lg="4">
                <v-card outlined class="elevation-3 rounded-xl mb-4" :color="diag.status === 'CRITICO'
                  ? 'red lighten-5'
                  : diag.status === 'ALERTA'
                    ? 'orange lighten-5'
                    : 'green lighten-5'
                  " style="border-width: 2px !important;" :style="{ borderColor: getStatusBorderColor(diag.status) }">
                  <v-card-title class="font-weight-black subtitle-1">{{ suc }}</v-card-title>
                  <v-card-text>
                    <v-chip :color="diag.status === 'CRITICO' ? 'red' : diag.status === 'ALERTA' ? 'orange' : 'green'" dark small class="mb-3 font-weight-bold px-4">
                      {{ diag.status }}
                    </v-chip>
                    <p class="text-body-2 mb-2"><strong>Análisis:</strong> {{ diag.analysis }}</p>
                    <p class="text-body-2 mb-3 grey--text text--darken-3"><strong>Acción:</strong> {{ diag.action }}</p>
                    
                    <v-divider class="mb-2"></v-divider>
                    
                    <div class="d-flex justify-space-between mt-2">
                      <span class="text-caption">Leads: <strong>{{ diag.leads }}</strong></span>
                      <span class="text-caption">Calidad:
                        <strong :class="diag.quality < 0.5 ? 'red--text' : 'green--text'">{{ (diag.quality * 100).toFixed(0) }}%</strong></span>
                    </div>
                    <div class="d-flex justify-space-between mt-1">
                      <span class="text-caption">Gasto: <strong>${{ diag.spend | decimales }}</strong></span>
                      <span class="text-caption">Presupuesto: <strong>${{ diag.budget | decimales }}</strong></span>
                    </div>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-4 bg-white border-top">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-3" text @click="dialogDiagnosticoLocal = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :timeout="2000">{{ snackbarText }}</v-snackbar>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import validarErrores from '@/mixins/validarErrores'
import carga from '@/components/alertas/carga.vue';
import { esLeadCompleto, costoONull, indicadoresHomologados } from '@/helpers/meta-ads-definiciones';

export default {
  mixins: [validarErrores, carga],
  filters: {
    decimales(valor) {
      if (valor === null || valor === undefined || valor === '-') return '-'
      return Number(valor).toLocaleString('es-MX', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    capitalize(value) {
      if (!value) return ''
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  data() {
    return {
      jsonDate: new Date().toISOString().slice(0, 10),
      idSchool: 1,
      snackbar: false,
      snackbarText: "",
      mainTab: 0,
      unicorniosTab: 0,
      apagarTab: 0,
      escalarTab: 0,
      sucCriticasTab: 0,
      prediccionesTab: 0,
      plataformasFacebookTab: 0,
      plataformasInstagramTab: 0,
      filterSucursales: "SIN_INFO",
      buscarEncargado: "",
      cargandoEncargados: false,
      guardandoEncargados: false,
      sucursalesEncargado: [],
      personasEncargado: [],
      headersEncargados: [
        { text: "Sucursal", value: "plantel" },
        { text: "Persona encargada", value: "id_usuario", sortable: false },
        { text: "", value: "acciones", sortable: false, align: "end", width: "140" }
      ],
      search: '',
      expanded: [],
      checklistClon: [],
      checklistOff: [],
      checklistApagados: [],
      checklistEscalar: [],
      checklistSucursalesCrit: [],
      expandedOerativos: [],
      dataAnalysis: {},
      paneles: [0, 1, 2, 3, 4, 5],
      panelsProducto: [0, 1, 2],
      dialogResumenOperativo: false,
      dialogCiudad: false,
      dialogTopGastosCiudad: false,
      dialogFechaDescargaReporte: false,
      dialogDetalleAccion: false,
      dialogDiagnosticoIA: false,
      dialogDiagnosticoLocal: false,
      localLevelDiagnoses: {},
      accionSeleccionada: null,
      ciudadSeleccionada: null,
      topInfo: null,
      today: new Date().toLocaleDateString('es-MX', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),

      accionesExplicadas: {
        APAGAR_YA: "Anuncio con CPA tóxico o sin conversión. Apágalo inmediatamente para evitar pérdida.",
        ESCALAR: "Anuncio rentable con buen CPA. Sube presupuesto 10-30%. ¡Aprovecha!",
        MANTENER: "Anuncio estable. No requiere acción urgente, pero vigílalo.",
        UNICORNIO: "¡ANUNCIO ESTELAR! CPA excelente + alto volumen. Clona YA y dale todo el presupuesto."
      },
      checklistUnicorniosEjecutados: null,
      checklistEscalados: null,
      checklistSucursalesCriticas: null,
      conjuntosCriticos: [],
      modalConjuntos: false,
      headersConjuntos: [
        { text: 'Sucursal', value: 'sucursal', width: '130' },
        { text: 'Campaña', value: 'campaña', width: '300' },
        { text: 'Conjunto', value: 'conjunto_de_anuncios', width: '150' },
        { text: 'Activos', value: 'anuncios_activos', align: 'center', width: '110' },
        { text: 'ID Anuncios', value: 'ids_anuncios', width: '200' }
      ]
    }
  },
  computed: {
    ...mapGetters("login", ["getdatosUsuarioERPERP"]),
    getDiagnosticoIA() {
      if (!this.dataAnalysis || !this.dataAnalysis.diagnostico_ia) return null;
      const raw = this.dataAnalysis.diagnostico_ia;
      return {
        escuela: raw.nivel_escuela || null,
        ciudades: raw.nivel_ciudad ? Object.entries(raw.nivel_ciudad).map(([nombre, data]) => ({ nombre, ...data })) : [],
        sucursales: raw.nivel_sucursal ? Object.entries(raw.nivel_sucursal).map(([nombre, data]) => ({ nombre, ...data })) : []
      };
    },
    getReportName() {
      if (!this.dataAnalysis) return ""
      return `meta_analyze_${this.dataAnalysis.date_report}_${this.dataAnalysis.time_slot}.json`
    },
    getCiudadesOrSucursales() {
      return this.idSchool == 1 ? this.getCiudades : this.getSucursales
    },
    getReportTimeSlot() {
      if (!this.dataAnalysis) {
        if (this.getHour < 9) return "Primer";
        if (this.getHour < 16) return "Segundo";
        return "Tercer";
      } else {
        if (this.dataAnalysis.time_slot == "A") return "Primer";
        if (this.dataAnalysis.time_slot == "B") return "Segundo";
        return "Tercer";
      }
    },
    getHour() {
      const now = new Date();
      return now.getHours()
    },
    getSuccess() {
      return !!this.dataAnalysis.success
    },
    getResumenOperativo() {
      const resumenOperativo = this.dataAnalysis.resumen_operativo

      if (resumenOperativo) {
        Object.entries(resumenOperativo.acciones).forEach(([key, value]) => {
          let coincidencias = this.getDetallesOperativos.filter(it => it.status == key.replace('_', ' '))
          resumenOperativo.acciones[key] = coincidencias.length
        })
      }

      return resumenOperativo || {}
    },
    getEstatusSucursales() {
      return this.dataAnalysis.estatus_sucursales || []
    },
    getTotal() {
      return this.dataAnalysis.resumen_financiero.panel_completo || {}
    },
    getCiudades() {
      const ciudades = this.dataAnalysis.resumen_financiero.por_ciudad || []
      ciudades.forEach(ciudad => {
        const topCiudad = this.getTop5GastosPorCiudad.find(fd => fd.ciudad === ciudad.nombre)
        ciudad.top_ciudad = topCiudad || { top5: [], cantidadAnuncios: 0 }
      })
      return ciudades.sort((a, b) => parseFloat(b.cumplimiento) - parseFloat(a.cumplimiento))
    },
    getSucursales() {
      return this.dataAnalysis.resumen_financiero.por_sucursal || []
    },
    getReporteGeneral() {
      return this.dataAnalysis.reporte_plataformas.general || {}
    },
    getReportePorCiudad() {
      return this.dataAnalysis.reporte_plataformas.por_ciudad || []
    },
    getReportePorSucursal() {
      return this.dataAnalysis.reporte_plataformas.por_sucursal || []
    },
    getReportePorProducto() {
      return this.dataAnalysis.reporte_plataformas.por_producto || []
    },
    getPanoramaGeneral() {
      return this.dataAnalysis.predicciones_inteligentes.panorama_general || {}
    },
    getPrediccionesPorCiudad() {
      return this.dataAnalysis.predicciones_inteligentes.por_ciudad || []
    },
    getPrediccionesPorSucursal() {
      return this.dataAnalysis.predicciones_inteligentes.por_sucursal || []
    },
    getInstruccionesClonacion() {
      let instrucciones = this.dataAnalysis.instrucciones_clonacion
      if (!instrucciones || (instrucciones.length == 1 && instrucciones.some(it => it.mensaje.includes("No se detectaron")))) {
        return []
      }
      return this.dataAnalysis.instrucciones_clonacion || []
    },
    getDetallesOperativos() {
      const detalles = this.dataAnalysis.detalles_operativos || []
      detalles.forEach((element, index) => {
        element.idRow = element.ad_name + '_' + index
      })
      return detalles
    },
    getGanadorGeneralColor() {
      return this.getReporteGeneral.ganador.includes('INSTAGRAM') ? 'pink darken-2' : 'blue darken-2'
    },
    getChecklistTotal() {
      return this.checklistClon.length + this.checklistEscalar.length + this.checklistOff.length + this.checklistSucursalesCrit.length
    },
    anunciosPorAccion() {
      if (!this.accionSeleccionada || !this.getDetallesOperativos) return []
      return this.getDetallesOperativos.filter(a => a.status === this.accionSeleccionada)
    },
    getConjuntosCriticos() {
      return this.dataAnalysis.conjuntos_criticos || []
    },
    getUnicornios() {
      if (!this.getDetallesOperativos) return []

      // Todos los unicornios detectados (del sistema + instrucciones manuales)
      const todosLosUnicornios = [
        ...this.getDetallesOperativos.filter(a => a.action === 'UNICORNIO'),
        ...this.getInstruccionesClonacion
      ]

      // Si no hay nada guardado en checklist → mostrar todos
      if (!this.checklistUnicorniosEjecutados || this.checklistUnicorniosEjecutados.length === 0) {
        return todosLosUnicornios
      }

      // Filtrar: mantener solo los que NO están en checklistUnicorniosEjecutados
      return todosLosUnicornios.filter(unicornio => {
        const yaEstaEjecutado = this.checklistUnicorniosEjecutados.some(ejecutado => {
          return (
            unicornio.origen.id_anuncio === ejecutado.origen_id_anuncio &&
            unicornio.destino.campana === ejecutado.destino_campana
          )
        })

        // Queremos los que NO están ejecutados → negamos
        return !yaEstaEjecutado
      })
    },

    getUnicorniosEjecutados() {
      // Si no hay datos o no hay ejecutados → vacío
      if (
        !this.getDetallesOperativos ||
        !this.checklistUnicorniosEjecutados ||
        this.checklistUnicorniosEjecutados.length === 0
      ) {
        return []
      }

      // Todos los unicornios detectados (sistema + manuales
      const todosLosUnicornios = [
        ...this.getDetallesOperativos.filter(a => a.action === 'UNICORNIO'),
        ...(this.getInstruccionesClonacion || [])
      ]

      // Mapa rápido: clave → registro completo de la BD (con toda la info
      const mapaEjecutados = new Map()
      this.checklistUnicorniosEjecutados.forEach(registro => {
        const clave = `${registro.origen_id_anuncio}|${registro.destino_campana}`
        mapaEjecutados.set(clave, {
          id: registro.id,
          usuario_ejecucion: registro.usuario_ejecucion || 'system',
          fecha_ejecucion: registro.fecha_ejecucion,     // string o Date del backend
          fecha_creacion: registro.fecha_creacion,
          prioridad: registro.prioridad,
          nombre_usuario_ejecuto: registro.nombre_usuario_ejecuto,
          mensaje_humano: registro.mensaje_humano
        })
      })

      // Filtramos y enriquecemos con la info de la BD
      return todosLosUnicornios
        .map(unicornio => {
          const clave = `${unicornio.origen.id_anuncio}|${unicornio.destino.campana}`
          const infoBD = mapaEjecutados.get(clave)

          // Si no está en la BD → no está ejecutado → lo ignoramos
          if (!infoBD) return null

          // Devolvemos el unicornio original + toda la metadata de ejecución
          return {
            ...unicornio,
            polinizacion_id: infoBD.id,
            aplicado_por: infoBD.usuario_ejecucion,
            aplicado_el: infoBD.fecha_ejecucion,
            creado_el: infoBD.fecha_creacion,
            prioridad: infoBD.prioridad,
            ejecutado_por: infoBD.nombre_usuario_ejecuto,
            mensaje_humano: infoBD.mensaje_humano
          }
        })
        .filter(Boolean) // quita los null
        .sort((a, b) => new Date(b.aplicado_el) - new Date(a.aplicado_el)) // más reciente primero
    },
    getApagarYa() {
      if (!this.getDetallesOperativos) return []

      const todosApagar = this.getDetallesOperativos.filter(a => a.action === 'APAGAR')

      if (!this.checklistApagados || !this.checklistApagados.length) return todosApagar

      const apagadosSet = new Set(
        this.checklistApagados.map(a => `${a.ad_id}|${a.campaign_name}`)
      )

      return todosApagar.filter(item => {
        const clave = `${item.ad_id}|${item.campaign_name}`
        return !apagadosSet.has(clave)
      })
    },

    // 2. Ya apagados (con info completa: quién, cuándo, etc.)
    getApagados() {
      if (!this.getDetallesOperativos || !this.checklistApagados || !this.checklistApagados.length) return []

      const todosApagar = this.getDetallesOperativos.filter(a => a.action === 'APAGAR')

      const mapaApagados = new Map()
      this.checklistApagados.forEach(reg => {
        if (reg.status_apagado === 1) {
          mapaApagados.set(`${reg.ad_id}|${reg.campaign_name}`, {
            apagado_por: reg.usuario_apagado || 'system',
            apagado_el: reg.fecha_apagado,
            creado_el: reg.fecha_creacion
          })
        }
      })

      return todosApagar
        .map(item => {
          const clave = `${item.ad_id}|${item.campaign_name}`
          const info = mapaApagados.get(clave)
          if (!info) return null

          return {
            ...item,
            // todo el objeto original (spend, cpm, reason, etc.)
            apagado_por: info.apagado_por,
            apagado_el: info.apagado_el,
            creado_el: info.creado_el
          }
        })
        .filter(Boolean)
        .sort((a, b) => new Date(b.apagado_el) - new Date(a.apagado_el))
    },
    getEscalar() {
      if (!this.getDetallesOperativos) return []

      const todos = this.getDetallesOperativos.filter(a => a.status === 'ESCALAR')

      if (!this.checklistEscalados || !this.checklistEscalados.length) return todos

      const escaladosSet = new Set(
        this.checklistEscalados.map(e => `${e.ad_id}|${e.campaign_name}`))

      return todos.filter(item => !escaladosSet.has(item.ad_id + '|' + item.campaign_name))
    },
    getEscalados() {
      if (!this.getDetallesOperativos || !this.checklistEscalados || !this.checklistEscalados.length) return []

      const todos = this.getDetallesOperativos.filter(a => a.status === 'ESCALAR')
      const mapa = new Map()
      this.checklistEscalados.forEach(reg => {
        mapa.set(`${reg.ad_id}|${reg.campaign_name}`, {
          escalado_por: reg.usuario_escalado,
          escalado_el: reg.fecha_escalado,
          creado_el: reg.fecha_creacion,
          gasto_sugerido: reg.gasto_sugerido_manana
        })
      })

      return todos
        .map(item => {
          const info = mapa.get(`${item.ad_id}|${item.campaign_name}`)
          if (!info) return null
          return { ...item, ...info }
        })
        .filter(Boolean)
        .sort((a, b) => new Date(b.escalado_el) - new Date(a.escalado_el))
    },

    encargadosPendientes() {
      return this.sucursalesEncargado.filter(item => this.encargadoSucursalCambio(item))
    },
    sucursalesCriticas() {
      if (!this.dataAnalysis || !this.dataAnalysis.estatus_sucursales) return []

      const filterSuc = this.mainTab === 5
        ? ['SIN_INFO', 'CRITICO', 'ALERTA']
        : [this.filterSucursales]

      const criticas = this.dataAnalysis.estatus_sucursales
        .filter(s => filterSuc.includes(s.estatus_global) && s.sucursal !== 'OTROS')

      // Si no hay checklist → mostrar todas
      if (!this.checklistSucursalesCriticas.length) return criticas

      const atendidasSet = new Set(
        this.checklistSucursalesCriticas.map(c => `${c.sucursal}|${c.estatus_global}`)
      )

      // Solo las que NO están atendidas
      return criticas.filter(s =>
        !atendidasSet.has(`${s.sucursal}|${s.estatus_global}`)
      )
    },

    // Bonus: ya atendidas (con metadata)
    sucursalesCriticasAtendidas() {
      if (!this.dataAnalysis || !this.dataAnalysis.estatus_sucursales || !this.checklistSucursalesCriticas.length) return []

      const mapa = new Map()
      this.checklistSucursalesCriticas.forEach(reg => {
        mapa.set(`${reg.sucursal}|${reg.estatus_global}`, {
          atendida_por: reg.usuario_atencion,
          atendida_el: reg.fecha_atencion,
          recomendacion: reg.recomendacion
        })
      })

      return this.dataAnalysis.estatus_sucursales
        .filter(s => ['SIN_INFO', 'CRITICO', 'ALERTA'].includes(s.estatus_global) && s.sucursal !== 'OTROS')
        .map(s => {
          const info = mapa.get(`${s.sucursal}|${s.estatus_global}`)
          if (!info) return null
          return { ...s, ...info }
        })
        .filter(Boolean)
        .sort((a, b) => new Date(b.atendida_el) - new Date(a.atendida_el))
    },
    totalPendientes() { return this.getUnicornios.length + this.getApagarYa.length + this.getEscalar.length + this.sucursalesCriticas.length },
    headersDetalleAccion() {
      return [
        { text: 'Ciudad', value: 'city' },
        { text: 'Sucursal', value: 'branch' },
        { text: 'Anuncio', value: 'ad_name' },
        { text: 'Gasto', value: 'spend', align: 'end' },
        { text: 'Leads WA', value: 'whatsapp_conversations' },
        { text: 'Costo x Chat', value: 'cost_per_whatsapp' },
        { text: 'Acción', value: 'action' }
      ]
    },
    getTop5GastosPorCiudad() {
      const detalles = this.getDetallesOperativos
      const porCiudad = {}
      detalles.forEach(item => {
        const ciudad = item.city || 'SIN CIUDAD'
        if (!porCiudad[ciudad]) porCiudad[ciudad] = []
        porCiudad[ciudad].push(item)
      })
      return Object.keys(porCiudad).map(ciudad => ({
        ciudad,
        totalGastado: porCiudad[ciudad].reduce((sum, i) => sum + (i.spend || 0), 0),
        cantidadAnuncios: porCiudad[ciudad].length,
        top5: porCiudad[ciudad].sort((a, b) => (b.spend || 0) - (a.spend || 0)).slice(0, 5)
      })).sort((a, b) => b.totalGastado - a.totalGastado)
    },
    getPorPlataformaPorSucursal() {
      const resultado = {
        facebook: {},
        instagram: {}
      };

      this.getReportePorSucursal.forEach(item => {
        const sucursal = item.sucursal;

        resultado.facebook[sucursal] = {
          gasto: parseFloat(item.facebook.gasto),
          leads: parseInt(item.facebook.leads),
          cpa: parseFloat(item.facebook.cpa),
          ganador: item.ganador.includes("FACEBOOK")
        };

        resultado.instagram[sucursal] = {
          gasto: parseFloat(item.instagram.gasto),
          leads: parseInt(item.instagram.leads),
          cpa: parseFloat(item.instagram.cpa),
          ganador: item.ganador.includes("INSTAGRAM")
        };
      });

      return resultado;
    },
    totalCriticos() {
      return this.conjuntosCriticos ? this.conjuntosCriticos.length : 0
    },
    getPorPlataformaPorCiudad() {
      const resultado = {
        facebook: {},
        instagram: {}
      };

      this.getReportePorCiudad.forEach(item => {
        const ciudad = item.ciudad;

        resultado.facebook[ciudad] = {
          gasto: parseFloat(item.facebook.gasto),
          leads: parseInt(item.facebook.leads),
          cpa: parseFloat(item.facebook.cpa),
          ganador: item.ganador.includes("FACEBOOK")
        };

        resultado.instagram[ciudad] = {
          gasto: parseFloat(item.instagram.gasto),
          leads: parseInt(item.instagram.leads),
          cpa: parseFloat(item.instagram.cpa),
          ganador: item.ganador.includes("INSTAGRAM")
        };
      });

      return resultado;
    },
    topSucursalesSobregasto() {
      return [...(this.dataAnalysis.resumen_financiero.por_sucursal || [])]
        .sort((a, b) => parseFloat(b.cumplimiento) - parseFloat(a.cumplimiento))
        .slice(0, 5)
    },
    headers() {
      let headers = [
        { text: '', value: 'data-table-expand' },
        { text: 'Ciudad', value: 'city', width: '100' },
        { text: 'Sucursal', value: 'branch' },
        { text: 'Producto', value: 'product' },
        { text: 'Schedule', value: 'schedule' },
        { text: 'Anuncio', value: 'ad_name' },
        { text: 'Gasto', value: 'spend', align: 'end' },
        { text: 'CPM', value: 'cpm', align: 'end' },
        { text: 'CTR %', value: 'ctr', align: 'end' },
        { text: 'Costo x WA', value: 'cost_per_whatsapp', align: 'end' },
        { text: 'Status', value: 'status', align: 'center' },
      ]

      if (this.idSchool == 2) {
        headers = headers.filter(it => it.text !== 'Ciudad')
      }

      return headers
    }
  },
  watch: {
    '$route'(to, from) {
      this.defineIdSchool()
      this.buscarEncargado = ""
      this.getMetaAnalysis()
      this.getEncargadosSucursal()
    },
    dataAnalysis(newVal) {
      if (newVal) {
        this.localLevelDiagnoses = this.generateLocalDiagnoses()
      }
    }
  },
  created() {
    this.defineIdSchool()
  },
  async mounted() {
    await this.getApagadosDB()
    await this.getEscaladosDB()
    await this.getSucursalesCriticasDB()
    this.getPolinizacionEjecutadas()
    await this.getMetaAnalysis()
    this.getEncargadosSucursal()
    this.localLevelDiagnoses = this.generateLocalDiagnoses()
  },
  methods: {
    defineIdSchool() {
      this.idSchool = this.$route.name == "optimizacionCampaniasInbi" ? 1 : 2
    },
    normalizarIdUsuario(valor) {
      if (valor === null || valor === undefined || valor === "") return null
      const n = Number(valor)
      if (!n) return null
      return n
    },
    encargadoSucursalCambio(item) {
      return this.normalizarIdUsuario(item.id_usuario) !== this.normalizarIdUsuario(item.id_usuario_original)
    },
    personasEncargadoDe(item) {
      const lista = this.personasEncargado
      const idUsuario = item ? this.normalizarIdUsuario(item.id_usuario) : null
      if (!idUsuario) return lista
      const existe = lista.some(persona => this.normalizarIdUsuario(persona.id_usuario) === idUsuario)
      if (existe) return lista
      return [{
        id_usuario: idUsuario,
        nombre_completo: item.nombre_encargado || ("Usuario " + idUsuario)
      }].concat(lista)
    },
    getEncargadosSucursal() {
      this.cargandoEncargados = true
      this.$http.get("api/meta/sucursal-encargados/" + this.idSchool)
        .then(r => {
          const data = r.data || {}
          const sucursales = Array.isArray(data.sucursales) ? data.sucursales : []
          const personas = Array.isArray(data.personas) ? data.personas : []
          this.sucursalesEncargado = sucursales.map(sucursal => {
            const idUsuario = this.normalizarIdUsuario(sucursal.id_usuario)
            return {
              id_plantel: sucursal.id_plantel,
              plantel: sucursal.plantel,
              id_usuario: idUsuario,
              id_usuario_original: idUsuario,
              nombre_encargado: sucursal.nombre_encargado || "",
              guardando: false
            }
          })
          this.personasEncargado = personas
        })
        .catch(e => this.validarError(e))
        .finally(() => {
          this.cargandoEncargados = false
        })
    },
    guardarEncargadoSucursal(item) {
      item.guardando = true
      const idUsuario = this.normalizarIdUsuario(item.id_usuario)
      this.$http.post("api/meta/sucursal-encargados/" + this.idSchool, {
        id_plantel: item.id_plantel,
        id_usuario: idUsuario
      })
        .then(() => {
          item.id_usuario = idUsuario
          item.id_usuario_original = idUsuario
          this.snackbar = true
          this.snackbarText = "Encargado guardado"
        })
        .catch(e => this.validarError(e))
        .finally(() => {
          item.guardando = false
        })
    },
    guardarTodosEncargados() {
      const pendientes = this.encargadosPendientes
      if (!pendientes.length) return
      this.guardandoEncargados = true
      const asignaciones = pendientes.map(item => ({
        id_plantel: item.id_plantel,
        id_usuario: this.normalizarIdUsuario(item.id_usuario)
      }))
      this.$http.post("api/meta/sucursal-encargados/" + this.idSchool, { asignaciones: asignaciones })
        .then(() => {
          pendientes.forEach(item => {
            item.id_usuario_original = this.normalizarIdUsuario(item.id_usuario)
          })
          this.snackbar = true
          this.snackbarText = "Encargados guardados"
        })
        .catch(e => this.validarError(e))
        .finally(() => {
          this.guardandoEncargados = false
        })
    },
    openDialogCiudad(ciudad) {
      this.ciudadSeleccionada = ciudad
      this.dialogCiudad = true
    },

    getTooltipAccion(accion) {
      return this.accionesExplicadas[accion] || 'Sin descripción'
    },
    getTotalGastado(top5) {
      return top5.reduce((sum, ad) => sum + (ad.spend || 0), 0)
    },
    chipColor(status) {
      const map = { 'URGENTE': 'red', 'IMPORTANTE': 'orange', 'REVISAR': 'yellow darken-3', 'OK': 'green' }
      return map[status] || 'grey'
    },
    getAccionColorClase(accion) {
      const colores = {
        UNICORNIO: 'purple',
        ESCALAR: 'green darken-2',
        MANTENER: 'blue darken-2',
        APAGAR_YA: 'red darken-4',
      }
      return colores[accion] || 'grey darken-1'
    },
    getIconoAccion(accion) {
      console.log();

      const iconos = {
        UNICORNIO: 'mdi-trophy',
        ESCALAR: 'mdi-trending-up',
        MANTENER: 'mdi-minus-circle',
        APAGAR_YA: 'mdi-fire',
      }
      return iconos[accion] || 'mdi-help-circle'
    },
    getAccionOrdenColor(orden) {
      if (orden.includes('APAGAR')) return 'red darken-2'
      if (orden.includes('URGENTE')) return 'deep-orange darken-3'
      if (orden.includes('BAJAR')) return 'orange darken-3'
      if (orden.includes('CAMBIAR') || orden.includes('EDITAR')) return 'amber darken-1'
      if (orden.includes('VIGILAR')) return 'blue darken-1'
      if (orden.includes('SIN PRESUPUESTO')) return 'blue-grey darken-1'
      return 'green darken-3'
    },
    getAccionColor(accion) {
      const colors = {
        APAGAR_YA: 'red',
        ESCALAR: 'green',
        MANTENER: 'blue',
        UNICORNIO: 'purple'
      }
      return colors[accion] || 'grey'
    },
    getGanadorProductoColor(ganador) {
      return ganador.includes('INSTAGRAM') ? 'pink darken-2' : 'blue darken-2'
    },
    getTagGanador(tag) {
      const key = tag.split(" ", 1)
      if (key && key[0]) {
        return key[0].toLowerCase()
      }

      return ""
    },
    getSucursalCardColor(estatus) {
      if (estatus.includes('CRITICO')) return 'red darken-3'
      if (estatus.includes('ALERTA')) return 'amber darken-3'
      if (estatus.includes('SIN_INFO')) return 'grey darken-2'
      return 'green darken-2'
    },
    getCampanaColor(count) {
      return count > 0 ? 'green' : 'red'
    },
    getClonacionColor(tipo) {
      return tipo === 'CLONACION_EXITOSA' ? 'green' : 'orange'
    },
    getClonacionIcon(tipo) {
      return tipo === 'CLONACION_EXITOSA' ? 'mdi-check' : 'mdi-alert'
    },
    getGanadorColor(ganador) {
      if (ganador.includes('FACEBOOK')) return 'blue darken-1'
      if (ganador.includes('INSTAGRAM')) return 'pink darken-2'
      return 'grey'
    },
    getPrediccionColor(color) {
      if (color === '🟢') return 'green'
      return 'red'
    },
    getCardColor(item) {
      if (!item || !item.cumplimiento) return 'grey'
      const v = parseFloat(item.cumplimiento.replace('%', '')) || 0
      if (v === 0 || item.presupuesto_diario === '0.00') return 'blue-grey lighten-1'
      if (v <= 100) return 'green darken-2'
      if (v <= 150) return 'lime darken-3'
      if (v <= 300) return 'amber darken-1'
      if (v <= 400) return 'orange darken-3'
      if (v <= 500) return 'deep-orange darken-4'
      return 'red darken-4'
    },
    getChipPresupuestoColor(estado) {
      if (estado.includes('SOBREGASTO')) return 'red darken-2'
      if (estado.includes('SUBGASTO')) return 'amber darken-1'
      if (estado.includes('SIN PRESUPUESTO')) return 'blue-grey darken-1'
      return 'green darken-3'
    },
    getTrendIssueClass(trend) {
      if (!trend) return ''
      if (trend.includes('+')) return 'red--text'
      if (trend.includes('-')) return 'green--text'
      return 'grey--text'
    },
    getTrendIssueColor(trend) {
      let color = ''
      const percentage = this.getPercentegeCPA(trend, false)
      if (typeof percentage === 'number') {
        if (percentage > 0) color = 'red--text'
        if (percentage < 0) color = 'green--text'
      }
      return color
    },
    getStatusColor(status) {
      const colors = {
        MANTENER: 'blue',
        UNICORNIO: 'purple',
        ESCALAR: 'green',
        'APAGAR YA': 'red'
      }
      return colors[status] || 'grey'
    },
    getNamingStatusColor(status) {
      return status === 'ERROR' ? 'red' : 'green'
    },
    getFormatColor(format) {
      return format === 'VIDEO' ? 'purple' : 'teal'
    },
    getCostoChatClass(costo) {
      return parseFloat(costo) > 40 ? 'red--text' : 'green--text'
    },
    openDialogTopGastosCiudad(ciudad) {
      ciudad.top_ciudad.top5.forEach((element, index) => {
        element.idRow = element.ad_name + '_' + index
      })
      this.topInfo = ciudad.top_ciudad
      this.dialogTopGastosCiudad = true
    },
    abrirDetalleAccion(accion) {
      accion = accion.replace('_', ' ')
      this.accionSeleccionada = accion
      this.dialogDetalleAccion = true
    },
    getStatusBorderColor(status) {
      if (status === 'CRITICO') return '#C62828';
      if (status === 'ALERTA') return '#EF6C00';
      return '#2E7D32';
    },
    generateLocalDiagnoses() {
      const diag = {};
      const homologados = indicadoresHomologados(this.dataAnalysis);
      let filas = [];

      if (homologados) {
        filas = (homologados.por_sucursal || []).map(s => ({
          sucursal: s.sucursal,
          spend: Number(s.gasto || 0),
          budget: s.presupuesto_diario,
          leads: s.prospectos || 0,
          completos: s.registros_completos || 0,
          cpaCalidad: s.costo_por_registro_completo,
        }));
      } else {
        const data = this.dataAnalysis || {};
        const sucursales = (data.resumen_financiero && data.resumen_financiero.por_sucursal) || [];
        const detalles = data.detalles_operativos || [];
        filas = sucursales.map(s => {
          const sucursalName = s.sucursal || s.nombre;
          const spend = parseFloat(s.gasto_ayer || s.gasto || 0);
          const adsSuc = detalles.filter(ad => (ad.branch || "").toUpperCase().includes(String(sucursalName || '').toUpperCase()));
          const completos = adsSuc.reduce((acc, ad) => {
            const details = (ad.crm_data && ad.crm_data.leads_details) ? ad.crm_data.leads_details : [];
            return acc + details.filter(esLeadCompleto).length;
          }, 0);
          return {
            sucursal: sucursalName,
            spend,
            budget: s.presupuesto_diario == null ? null : parseFloat(s.presupuesto_diario),
            leads: parseInt(s.leads_ayer || s.leads || 0),
            completos,
            cpaCalidad: costoONull(spend, completos),
          };
        });
      }

      filas.forEach(f => {
        const sucursalName = f.sucursal;
        const spend = f.spend;
        const budget = f.budget == null ? null : Number(f.budget);
        const leads = f.leads;
        const cpaCalidad = f.cpaCalidad;
        const quality = leads > 0 ? f.completos / leads : 0;

        let status = "SANO";
        let analysis = "Operación estable.";
        let action = "Mantener estrategia.";

        if (cpaCalidad == null && spend > 50) {
          status = "CRITICO";
          analysis = `🚨 DESANGRE: $${spend.toFixed(2)} gastados sin registros completos.`;
          action = "APAGAR campañas tóxicas YA.";
        } else if (cpaCalidad != null && cpaCalidad > 40 && spend > 50) {
          status = "CRITICO";
          analysis = `🚨 DESANGRE: CPA de calidad en $${cpaCalidad.toFixed(2)} (${((1 - quality) * 100) | 0}% basura).`;
          action = "APAGAR campañas tóxicas YA.";
        } else if (leads < 5 && spend > 0) {
          status = "ALERTA";
          analysis = "⚠️ INANICIÓN: Muy pocos leads para el gasto realizado.";
          action = "Revisar anuncios o aumentar presupuesto.";
        } else if (budget != null && spend > budget && quality > 0.6) {
          status = "SANO";
          analysis = "📈 Inversión agresiva con buena calidad.";
          action = "Mantener y optimizar CPA.";
        }

        diag[sucursalName] = { status, analysis, action, leads, quality, spend, budget };
      });
      return diag;
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        this.snackbar = true
        this.snackbarText = 'Copiado al portapapeles'
      })
    },
    getMetaAnalysis() {
      this.cargar = true
      this.$http.get('api/meta/analyze/report/' + this.idSchool)
        .then(r => {
          if (r.data.success) {
            this.dataAnalysis = r.data
          }
        })
        .catch(e => this.validarError(e.response.data.message || 'Error'))
        .finally(() => this.cargar = false)
    },

    getMetaAnalysisByDate() {
      this.cargar = true
      this.$http.post('api/meta/analyze/report/' + this.idSchool, {fecha: this.jsonDate})
        .then(r => {
          if (r.data.success) {
            this.descargarJSON(r.data)
            this.dialogFechaDescargaReporte = false
          }
        })
        .catch(e => this.validarError(e.response.data.message || 'Error'))
        .finally(() => this.cargar = false)
    },

    crearOActualizarPolinizacion(unicornio) {
      this.cargar = true
      unicornio.usuario = this.getdatosUsuarioERPERP.id_usuario
      this.$http.post('api/polinizacion/toggle', unicornio)
        .then(r => {
          if (r.data.success) {
            this.snackbar = true
            this.snackbarText = r.data.message
            this.getPolinizacionEjecutadas()
          }
        })
        .catch(e => this.validarError(e.response.data.message || 'Error'))
        .finally(() => this.cargar = false)
    },

    async apagarAnuncio(item) {
      this.cargar = true
      item.usuario = this.getdatosUsuarioERPERP.id_usuario
      this.$http.post('api/polinizacion/toggleApagar', item)
        .then(r => {
          if (r.data.success) {
            this.snackbar = true
            this.snackbarText = r.data.message
            this.getApagadosDB()
          }
        })
        .catch(e => this.validarError(e.response.data.message || 'Error'))
        .finally(() => this.cargar = false)
    },

    async getApagadosDB() {
      try {
        const res = await this.$http.get('/api/polinizacion/apagados')
        this.checklistApagados = res.data.data
      } catch (error) {
        console.error("Error cargando apagados:", error)
        this.$toast.error("No se pudieron cargar los anuncios apagados")
      }
    },

    getPolinizacionEjecutadas() {
      this.cargar = true
      this.$http.get('api/polinizacion/ejecutadas')
        .then(r => {
          if (r.data.success) {
            const { data: ejecutadas } = r.data

            if (ejecutadas && ejecutadas.length) {
              this.checklistUnicorniosEjecutados = ejecutadas
            }
          }
        })
        .catch(e => this.validarError(e.response.data.message || 'Error'))
        .finally(() => this.cargar = false)
    },

    async getEscaladosDB() {
      try {
        const res = await this.$http.get('/api/polinizacion/escalados')
        this.checklistEscalados = res.data.data
      } catch (e) {
        console.error(e)
      }
    },

    async escalarAnuncio(anuncio) {
      try {
        await this.$http.post('/api/polinizacion/toggleEscalar', {
          ad_id: anuncio.ad_id,
          campaign_name: anuncio.campaign_name,
          ad_name: anuncio.ad_name,
          sucursal: anuncio.branch || anuncio.city,
          reason: anuncio.reason,
          gasto_sugerido_manana: anuncio.gasto_sugerido_manana,
          usuario: this.getdatosUsuarioERPERP.id_usuario

        })
        await this.getEscaladosDB()
      } catch (e) {
        console.error(e);

      }
    },

    async getSucursalesCriticasDB() {
      try {
        const res = await this.$http.get('/api/polinizacion/atendidas')
        this.checklistSucursalesCriticas = res.data.data
      } catch (e) {
        console.error("Error cargando sucursales críticas atendidas")
      }
    },

    async atenderSucursal(sucursalObj) {
      try {
        await this.$http.post('/api/polinizacion/toggleAtender', {
          sucursal: sucursalObj.sucursal,
          estatus_global: sucursalObj.estatus_global,
          recomendacion: sucursalObj.recomendacion,
          usuario: this.getdatosUsuarioERPERP.id_usuario
        })
        await this.getSucursalesCriticasDB()
      } catch (e) {
        console.error(e);

      }
    },
    descargarJSON(json) {
      const jsonString = JSON.stringify(json, null, 2);
      const blob = new Blob([jsonString], { type: 'application/json' });

      // Generamos una URL temporal para el Blob
      const url = window.URL.createObjectURL(blob);

      // Creamos un enlace <a> invisible
      const link = document.createElement('a');
      link.href = url;
      link.download = 'report.json'; // Nombre del archivo descargado (puedes cambiarlo)

      // Agregamos al DOM, clickeamos y removemos
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Liberamos la memoria
      window.URL.revokeObjectURL(url);
    },
  }
}
</script>

<style scoped>
.v-data-table>>>th {
  font-weight: bold !important;
}
.v-picker__title {
  color: #757575 !important; /* grey darken-1 */
}

/* Flechas de navegación en gris (opcional) */
.v-date-picker-header .v-btn {
  color: #9e9e9e !important; /* grey */
}
</style>
